<template>
  <div v-if="subjectProfile != null">
    <span v-if="subjectProfile.name">{{ subjectProfile.name }} &ndash; </span>
    <span v-if="subjectProfile.gender">{{ subjectProfile.gender }}, </span>
    <span v-if="subjectProfile.age">{{ subjectProfile.age }} let, </span>
    <span v-if="subjectProfile.weight">{{ subjectProfile.weight }} kg, </span>
    <span v-if="subjectProfile.height">{{ subjectProfile.height }} cm, </span>
    <span v-if="subjectProfile.shoeSize">bota:{{ subjectProfile.shoeSize }}, </span>
    <span v-if="subjectProfile.abilityLevel">úroveň: {{ subjectProfile.abilityLevel }}</span>
  </div>
</template>

<script>
export default {
  name: "SubjectProfileCompact",

  components: {},

  props: {
    subjectProfile: {
      type: Object
    },
  },
};
</script>
